export const VOICE_PROVIDERS = {
  CallHQ: [
    {
      label: 'Priya – 30F Indian | Charming & Professional',
      value: 'neha',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/bc752145-a261-41b2-a3f5-2137e842f628-1750160867162-2f9d90ef-fd63-4bee-b1df-870a97a5e86a-mono.wav',
    },
    {
      label: 'Sierra – 26F White | Calming & Professional',
      value: 'paige',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/effc4c64-f82f-43db-95a6-d0fcb0d19bbe-1750159779319-703683de-dcd4-49d5-a2e7-992c4ea856a1-mono.wav',
    },
    {
      label: 'Arjun – 24M Indian | Bright & Cheerful',
      value: 'rohan',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/8161c04e-e23d-4aa6-ba36-0e63f6b01761-1750159893558-b2336b21-cf84-4346-9a3a-b059817656c7-mono.wav',
    },
    {
      label: 'Emily – 22F Asian | Soothing & Gentle',
      value: 'hana',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/d9e73acc-b7aa-4565-b760-4883d18afc38-1750160005872-1f1ddfcb-8311-4404-a973-0d84ce999454-mono.wav',
    },
    {
      label: 'Liam – 25M Canadian | Friendly & Professional',
      value: 'elliot',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/dcafd5da-14e4-4028-896c-0908476e7356-1750160108136-a0332730-0b4b-45d3-a296-65e9338b7bc6-mono.wav',
    },
    {
      label: 'Rachel – 23F American | Soft-Spoken & Clear',
      value: 'kylie',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/67cb3db8-cf75-45be-bde6-52ab84e426a3-1750160197410-91ed8549-eb33-4bbf-b2ac-761d2870b8e6-mono.wav',
    },
    {
      label: 'Monica – 25F American | Southern Accent',
      value: 'savannah',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/0c715e96-7fee-4207-ba09-bd6a9445b603-1750160337248-5b6a2e13-f5e5-48db-a40a-b43a9e7cc47f-mono.wav',
    },
    {
      label: 'Ryan – 22M White | Deep Tone & Calming',
      value: 'cole',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/3e7afb83-2c58-4439-acc6-4d8b883f559e-1750160408872-967b5acc-4228-4147-9dcc-b6d2014161ca-mono.wav',
    },
    {
      label: 'Garry – 24M White | Energetic & Clear',
      value: 'harry',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/0eeadb08-d9d4-49aa-9e0f-9eea5eb9ebf6-1750160513253-88edb6bb-28e6-466e-bf34-5410ce0b79a5-mono.wav',
    },
    {
      label: 'Tessa – 26F | Quippy & Lighthearted',
      value: 'spencer',
      demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/6f3544ec-21de-4a1e-bdef-910eebec047b-1750160622450-ce798bb0-b0bf-420c-b2fb-f0e778953f6f-mono.wav',
    },
    { label: 'Maya - – 22F Asian | Soothing & Gentle', value: 'Lily', demoUrl: 'https://callhq.s3.ap-south-1.amazonaws.com/call_jarvis/8f12eb2d-7fa7-4e8d-8608-9e25fcb277a3-1750659828188-03577ae5-c35b-4c4d-be0d-705c9b498bb5-mono.wav' },
    
  ],
};